module.exports = __webpack_public_path__ + "img/roof-pitch.0f368230.png";